const schema = () => ({
  type: "object",
  required: [],
  properties: {
    title: {
      type: "string",
      title: "عنوان",
    },
  },
});

export default schema;
